import { gql } from '@apollo/client'

import { TaskTemplateFragment } from '../fragments'

export const MUTATION_CREATE_TASK_TEMPLATE = gql`
  mutation createTaskTemplate($input: TaskTemplateCreateInput!) {
    createTaskTemplate(input: $input) {
      ...TaskTemplateFragment
    }
  }
  ${TaskTemplateFragment}
`

export const MUTATION_UPDATE_TASK_TEMPLATE = gql`
  mutation updateTaskTemplate($input: TaskTemplateUpdateInput!) {
    updateTaskTemplate(input: $input) {
      ...TaskTemplateFragment
    }
  }
  ${TaskTemplateFragment}
`

export const MUTATION_DELETE_TASK_TEMPLATE = gql`
  mutation deleteTaskTemplate($id: ID!) {
    deleteTaskTemplate(id: $id)
  }
`

export const MUTATION_SORT_TASK_TEMPLATES = gql`
  mutation sortTaskTemplates($input: TaskTemplatesSortInput!) {
    sortTaskTemplates(input: $input) {
      ...TaskTemplateFragment
    }
  }
  ${TaskTemplateFragment}
`
